import React, { useState, useEffect } from 'react';
import { Observable } from 'rxjs';
import { DropdownWithList } from '../../index';

export interface listProps {
    list: any,
    itemSelected: any,
    setLength?: number,
    changeZIndex?: Function,
    isSkuGroupSearch?: boolean,
    forceInput?: boolean,
    qtyOnBlur?: (qty: any) => Observable<any>
    inputIdentifier: string;
    inputLabel: string;
}

export const DropdownListView = ({ ...props }: listProps) => {
    const moreStr: string = "More";
    const [labelVal, setLabelVal] = useState(props.list[0].text);
    const [value, setValue] = useState(props.list[0].value);

    const [storedValue, setStoredValue] = useState();
    const [storedLabelValue, setStoredLabelValue] = useState();

    useEffect(() => {
        if (storedValue && value !== storedValue) {
            if (storedLabelValue === moreStr) {
                setValue(props.list[0].value);
                setLabelVal(props.list[0].text);
            } else {
                setValue(storedValue);
                setLabelVal(storedLabelValue);
            }
        }
    }, [storedValue, storedLabelValue]);

    useEffect(() => {
        setValue(props.list[0].value);
        setStoredValue(props.list[0].value);
        setLabelVal(props.list[0].text);
        setStoredLabelValue(props.list[0].text);
        props.itemSelected && props.itemSelected(props.list[0].value, props.list[0].text);
    }, [props.list[0]?.value]);

    useEffect(() => {
        if (value !== moreStr && storedValue === moreStr) {
            setStoredValue(value);
            setStoredLabelValue(labelVal);
        }
    }, [value, labelVal])

    const setValLabel = (selectedValue: any, selectedText: string) => {
        setValue(selectedValue)
        setLabelVal(selectedText)
        props.itemSelected && props.itemSelected(selectedValue, selectedText)
    }

    return (
        <div className="dropdown-container">
            <DropdownWithList inputRequired inputString="More" list={props.list} isValid setValue={setValLabel} label={labelVal} value={value} setLength={props.setLength}
                changeZIndex={props.changeZIndex} storedValue={storedValue} setStoredValue={setStoredValue} setStoredLabelValue={setStoredLabelValue}
                isSkuGroupSearch={props.isSkuGroupSearch} qtyOnBlur={props.qtyOnBlur} forceInput={props.forceInput} inputIdentifier={props.inputIdentifier} inputLabel={props.inputLabel} />
        </div>
    );
}